import React from "react"

import * as S from "./form-error.styles"

const FormError = ({ errorMessage, style }) => (
  <S.ErrorMessage style={style} className="error-display">
    {errorMessage}
  </S.ErrorMessage>
)

export default FormError;